import itemStyle from './funnel.data.itemStyle'
import label from './funnel.data.label'
import labelLine from './funnel.data.labelLine'
import emphasis from './funnel.data.emphasis'
import tooltip from './funnel.data.tooltip'

export default {
  name: "data",
  nickname: "数据",
  desc: "系列中的数据内容数组。数组项可以为单个数值，如：",
  type: "array",
  props: {
    name: {
      name: "name",
      nickname: "名称",
      desc: "数据项名称。",
    },
    value: {
      name: "value",
      nickname: "值",
      desc: "数据值。",
      type: "pureValue",
    },
    itemStyle,
    label,
    labelLine,
    emphasis,
    tooltip,
  },
}
